/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useQuery } from "@apollo/client";
import { TextField, Autocomplete } from "@mui/material";
import { FIND_MANY_CODES_QUERY } from "../../graphql";

const QualificationSelectMUI = ({
  name,
  value,
  label,
  placeholder,
  disabled,
  required,
  showAllOption,
  entity,
  getValue,
  setValue,
  onChange,
  valueIsLabel,
  returnLabelOnChange,
}) => {
  const [formattedOptions, setFormattedOptions] = useState([]);
  const { data: CodesData, loading: qualificationTitlesLoading } = useQuery(
    FIND_MANY_CODES_QUERY,
    {
      variables: {
        orderBy: [{ title: "asc" }],
        distinct: ["title"],
        where: { entity: { equals: entity } },
      },
    }
  );

  const selectedOption = React.useMemo(() => {
    if (!formattedOptions?.length) return null;
    if (valueIsLabel) {
      return formattedOptions.find((opt) => opt.label === value) || null;
    }
    return formattedOptions.find((opt) => opt.value === value) || null;
  }, [formattedOptions, value, valueIsLabel]);

  useEffect(() => {
    if (CodesData && CodesData.findManyCodes.length > 0) {
      const fOptions = CodesData.findManyCodes
        .filter((c) => c?.id && c?.title)
        .map((code) => ({
          value: code.id,
          label: code?.title,
        }));

      if (showAllOption) {
        fOptions.unshift({ value: "", label: "All" });
      }

      setFormattedOptions(fOptions);
    }
  }, [CodesData, entity, showAllOption]);

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(o, v) => o.value === v?.value}
      isRequired={required}
      loading={qualificationTitlesLoading}
      options={formattedOptions}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      size="medium"
      value={getValue(selectedOption)}
      onChange={(_, option) => {
        if (returnLabelOnChange) {
          onChange(name, option?.label ?? "");
          return;
        }
        onChange(name, setValue(option?.value));
      }}
    />
  );
};

QualificationSelectMUI.propTypes = {
  entity: PropTypes.string.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  showAllOption: PropTypes.bool,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  onChange: PropTypes.func,
  valueIsLabel: PropTypes.bool,
  returnLabelOnChange: PropTypes.bool,
};

QualificationSelectMUI.defaultProps = {
  name: "",
  placeholder: "",
  label: "",
  disabled: false,
  required: false,
  showAllOption: false,
  getValue: (x) => x,
  setValue: (x) => x,
  onChange: () => {},
  valueIsLabel: false,
  returnLabelOnChange: false,
};

export default QualificationSelectMUI;
